export const SCHEME_GROUP = {
  width: 184,
  height: 252,
};

export const FIRST_SCENE_GROUP_ID = "1-group";
export const FIRST_SCENE_ID = "1";

export function isFirstSceneNode(node) {
  if (!node) return false;
  return node.type === "first-scene-node" || node.id === FIRST_SCENE_ID;
}

export function isFirstSceneGroup(node) {
  if (!node) return false;
  return node.id === FIRST_SCENE_GROUP_ID;
}

export function isProtectedSchemeNode(node) {
  return isFirstSceneNode(node) || isFirstSceneGroup(node);
}

export const SCHEME_SCENE = {
  x: 0,
  y: 34,
  width: 184,
  height: 132,
};

export const SCHEME_BUTTON = {
  width: 160,
  height: 32,
  x: 12,
  topY: 182,
  bottomY: 216,
};

export function getGroupStyle() {
  return {
    width: SCHEME_GROUP.width,
    height: SCHEME_GROUP.height,
    backgroundColor: "transparent",
    border: "none",
  };
}

export function getSceneStyle() {
  return {
    width: SCHEME_SCENE.width,
    height: SCHEME_SCENE.height,
    backgroundColor: "transparent",
    border: "none",
  };
}

export function getButtonStyle() {
  return {
    width: SCHEME_BUTTON.width,
    height: SCHEME_BUTTON.height,
    backgroundColor: "transparent",
    border: "none",
  };
}

export const TRAINER_SCHEME_GROUP = {
  width: 184,
  height: 292,
};

export const TRAINER_BUTTON_SLOTS = ["first", "second", "third", "fourth"];

export const TRAINER_BUTTON_Y = {
  first: 170,
  second: 192,
  third: 214,
  fourth: 236,
};

export function getTrainerGroupStyle() {
  return {
    width: TRAINER_SCHEME_GROUP.width,
    height: TRAINER_SCHEME_GROUP.height,
    backgroundColor: "transparent",
    border: "none",
  };
}

export function getTrainerButtonPosition(slot) {
  return {
    x: SCHEME_BUTTON.x,
    y: TRAINER_BUTTON_Y[slot] ?? TRAINER_BUTTON_Y.first,
  };
}

export function getNextTrainerButtonSlot(existingButtons) {
  const used = new Set(
    (existingButtons ?? []).map((node) => node.data?.buttonPosiiton)
  );
  return TRAINER_BUTTON_SLOTS.find((slot) => !used.has(slot)) ?? null;
}

export function getButtonPosition(slot) {
  if (TRAINER_BUTTON_Y[slot] != null) {
    return getTrainerButtonPosition(slot);
  }
  return {
    x: SCHEME_BUTTON.x,
    y: slot === "top" ? SCHEME_BUTTON.topY : SCHEME_BUTTON.bottomY,
  };
}

export function isTrainerButtonSlot(slot) {
  return TRAINER_BUTTON_SLOTS.includes(slot);
}

export function stripSchemeTransient(nodes) {
  return nodes.map((node) => {
    const cleaned = { ...node };

    if (cleaned.data?.isSceneSelected !== undefined) {
      const { isSceneSelected, isActive, ...rest } = cleaned.data;
      cleaned.data = rest;
    } else if (cleaned.data?.isActive !== undefined) {
      const { isActive, ...rest } = cleaned.data;
      cleaned.data = rest;
    }

    if (cleaned.type === "group") {
      cleaned.className = "scheme-group";
      if (cleaned.style) {
        const { zIndex, ...restStyle } = cleaned.style;
        cleaned.style = restStyle;
      }
    }

    return cleaned;
  });
}

export function normalizeSchemeNodes(nodes) {
  if (!nodes?.length) return nodes;

  return nodes.map((node) => {
    if (node.type === "group") {
      const normalized = {
        ...node,
        dragHandle: ".scheme-group-drag-handle",
        draggable: true,
        className: "scheme-group",
        style: { ...node.style, ...getGroupStyle() },
      };

      if (isFirstSceneGroup(node)) {
        normalized.deletable = false;
      }

      return normalized;
    }

    if (node.type === "input" && node.parentId) {
      const slot = node.data?.buttonPosiiton ?? "bottom";
      const resolvedSlot = isTrainerButtonSlot(slot)
        ? slot
        : slot === "top"
          ? "top"
          : "bottom";
      return {
        ...node,
        className: "scheme-button",
        position: getButtonPosition(resolvedSlot),
        style: getButtonStyle(),
        draggable: false,
      };
    }

    if (node.type === "node-with-toolbar" || node.type === "first-scene-node") {
      const normalized = {
        ...node,
        className: "scheme-scene",
        position: { x: SCHEME_SCENE.x, y: SCHEME_SCENE.y },
        style: getSceneStyle(),
        draggable: false,
      };

      if (isFirstSceneNode(node)) {
        normalized.deletable = false;
      }

      return normalized;
    }

    return node;
  });
}
